import styled, { css } from 'styled-components';
import { media } from 'src/ui/common/mixins/media';
import { FlexBox } from 'src/ui/common/atoms/flex-box';


export const StyledCollections = styled.div`
  display: flex;
  flex: 1 0 auto;
  align-items: flex-start;
  flex-direction: column;
  
  span {
    margin-bottom: 10px;
    margin-right: 30px;
    
    ${media.sm`
    margin-bottom: 0;
    flex: 0 0 auto;
  `}
  }
  
  div {
    width: 100%;

    ${media.sm(css`
      width: initial;
  `)}
    
    &:nth-last-of-type(1) {
      flex: 2;
    }
  }

  ${media.sm(css`
    flex-direction: row;
    align-items: center;
  `)}
`;

export const StyledTotal = styled(FlexBox)`
    svg {
      cursor: pointer;
      margin: auto 9px 10px;

      ${media.sm(css`
        margin: auto 9px;
      `)}
    }
`;